import { gql } from "@grandvisionhq/graphql";
const baseVariantFragment = gql`
  fragment BaseVariantFragment on Variant {
    sku
    erpId
    description
    displayName
    tags {
      key
      value
    }
    inventory {
      totalQuantity
    }
    bestPrice
    priceList {
      priceType
      pricePerUnit {
        amount
        currencyCode
      }
      priceSegment {
        channelKey
      }
      originalPrice {
        amount
        currencyCode
      }
      discountedPrice {
        price {
          amount
          currencyCode
        }
        discountInformation {
          type
          value
          description {
            value
            locale
          }
        }
      }
    }
    media {
      images {
        url
        dimensions {
          w
          h
        }
        label
      }
    }
    ... on FrameVariant {
      variantTypeDetails {
        frameFeatures {
          color
          size {
            displayName
            size
          }
        }
        lensFeatures {
          lensColor
        }
      }
    }
    ... on SunglassesVariant {
      variantTypeDetails {
        maybeFrameFeatures: frameFeatures {
          color
          size {
            displayName
            size
          }
        }
        maybeLensFeatures: lensFeatures {
          lensColor
        }
      }
    }
    ... on ReadyReaderVariant {
      variantTypeDetails {
        maybeFrameFeatures: frameFeatures {
          color
          size {
            displayName
            size
          }
        }
        maybeLensFeatures: lensFeatures {
          lensColor
        }
      }
    }
  }
`;
export {
  baseVariantFragment
};
//# sourceMappingURL=base-variant.js.map
